<script setup lang="ts">
import {apps, LegacyOrder, legacyOrderKey, useContext} from "@hantera/portal-app";
import OrderAddresses from "@/views/LegacyOrder/OrderAddress/LegacyOrderAddresses.vue";
import OrderSummary from "@/components/LegacyOrder/OrderSummary";
import OrderCustomer from "@/components/LegacyOrder/OrderCustomer";
import AppSlotView from "@/AppSlotView.vue";
import OrderNotes from "@/components/LegacyOrder/OrderNotes";
import {inject} from "vue";

const context = useContext()

const order = inject(legacyOrderKey, {} as any)

function openOrder(order: LegacyOrder) {
  context.openView(
    '/legacy-order',
    {
      query: {
        id: order.orderId
      }
    }
  )
}

</script>

<template>
  <AppSlotView :slot="apps.legacySlots.legacyOrder.details.beforeSummary" />
  <OrderSummary />
  <AppSlotView :slot="apps.legacySlots.legacyOrder.details.afterSummary" />

  <AppSlotView :slot="apps.legacySlots.legacyOrder.details.beforeNotes" />
  <OrderNotes />
  <AppSlotView :slot="apps.legacySlots.legacyOrder.details.afterNotes" />

  <AppSlotView :slot="apps.legacySlots.legacyOrder.details.beforeAddress" />
  <OrderAddresses />
  <AppSlotView :slot="apps.legacySlots.legacyOrder.details.afterAddress" />

  <AppSlotView :slot="apps.legacySlots.legacyOrder.details.beforeCustomer" />
  <OrderCustomer @open-order="openOrder" />
  <AppSlotView :slot="apps.legacySlots.legacyOrder.details.afterCustomer" />
</template>

<style scoped>

</style>